import { defineStore } from 'pinia';
import userCategory from '@/services/categoryService';
import { Category } from '@/types/category';

// Create a new store instance
export const UseStoreCategory = defineStore('CategoryStore', {
  state: () => ({
    category: [] as Category[],
  }),
  actions: {
    async loadCategories() {
      await userCategory.loadCategory();
    },
    async setCategory(categorie: Category) {
      await this.category.push(categorie);
    },
    async setAllCategory(category: Category[]) {
      this.category = category;
    },
    async clearCategory() {
      this.category.splice(0, this.category.length);
    },
  },
  getters: {
    getCategoryById: (state) => {
      return (id: number) => state.category.find(c => c.ID === id);
    },
  },
});
